import api from "@modules/api/api";
import { useMutation } from "@tanstack/react-query";
import { BillOfSalePersonalInfo } from "../types/BillOfSalePersonalInfo";

interface EmailPrivateBillOfSaleRequest {
  id: string;
  email: string;
  buyerInformation: BillOfSalePersonalInfo;
  sellerInformation: BillOfSalePersonalInfo;
  userPersonalInfoTypeId: number;
  locale: string;
}

const postEmailPrivateBillOfSale = async ({
  id,
  email,
  buyerInformation,
  sellerInformation,
  userPersonalInfoTypeId,
  locale,
}: EmailPrivateBillOfSaleRequest) => {
  await api.rawPost(`api/private-bill-of-sales/${id}/send`, {
    json: {
      email,
      buyerInformation,
      sellerInformation,
      userPersonalInfoTypeId,
    },
    headers: { "Accept-Language": locale },
  });
};

export default function useEmailPrivateBillOfSaleMutation() {
  return useMutation({ mutationFn: postEmailPrivateBillOfSale });
}
